import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import { getDetailLink, getItemPrimaryImage, getDateLocale } from "../utils/utilFunction";
import bosPng from "../assets/bos.png";

function RandomArticleCard({ dailyItems = [] }) {
  const [randomItem, setRandomItem] = useState(null);

  useEffect(() => {
    if (dailyItems && dailyItems.length > 0) {
      // Rastgele bir madde seç
      const randomIndex = Math.floor(Math.random() * dailyItems.length);
      setRandomItem(dailyItems[randomIndex]);
    }
  }, [dailyItems]);

  if (!randomItem) {
    return null;
  }

  // HTML entity'leri decode et
  const decodeHtmlEntities = (text) => {
    if (!text) return "";
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  };

  // HTML içeriğini temizle ve 500 karaktere kadar göster
  const stripHtml = (html) => {
    if (!html) return "";
    // Önce HTML tag'lerini kaldır
    let cleanText = html.replace(/<[^>]*>/g, "");
    // Sonra HTML entity'leri decode et
    cleanText = decodeHtmlEntities(cleanText);
    return cleanText.trim();
  };

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    const cleanText = stripHtml(text);
    if (cleanText.length <= maxLength) return cleanText;
    return cleanText.substring(0, maxLength).trim() + "...";
  };

  const truncatedContent = truncateText(randomItem.itemText || randomItem.subText || "", 500);

  return (
    <div className="random-article-card">
      <div className="d-flex justify-content-between mb-3">
        <h2 className="title _set">Rastgele Madde</h2>
        <Link className="seeAll" onClick={(e) => {
          e.preventDefault();
          if (dailyItems && dailyItems.length > 1) {
            let nextIndex;
            do {
              nextIndex = Math.floor(Math.random() * dailyItems.length);
            } while (dailyItems[nextIndex] === randomItem && dailyItems.length > 1);
            setRandomItem(dailyItems[nextIndex]);
          }
        }}>
          Yenile
        </Link>
      </div>
     
      <div className="random-article-card__content">
        {randomItem.primaryImage && (
          <div className="random-article-card__image">
            <Link to={getDetailLink(randomItem)}>
              <Image
                alt={randomItem.title}
                src={getItemPrimaryImage(randomItem.primaryImage)}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = bosPng;
                }}
              />
            </Link>
          </div>
        )}
        <div className="random-article-card__body">
          <div className="random-article-card__date">
            {getDateLocale(randomItem.releaseDate || randomItem.updateDate)}
          </div>
          <h3 className="random-article-card__title">
            <Link to={getDetailLink(randomItem)}>{randomItem.title}</Link>
          </h3>
          {randomItem.definition && (
            <div className="random-article-card__definition">{randomItem.definition}</div>
          )}
          <div className="random-article-card__text">{truncatedContent}</div>
          <div className="random-article-card__footer">
            {randomItem.writerName && (
              <div className="random-article-card__authors">
                <span>Yazar: </span>
                {randomItem.writerName.split(",").map((writer, key) => {
                  const writerId = randomItem.userIdList && randomItem.userIdList !== "" 
                    ? randomItem.userIdList.split(",")[key] 
                    : randomItem.userId;
                  return (
                    <Link
                      key={key}
                      to={`/yazar-detay/${writerId}/${writer.trim()}`}
                    >
                      {writer.trim()}
                      {key < randomItem.writerName.split(",").length - 1 ? ", " : ""}
                    </Link>
                  );
                })}
              </div>
            )}
            <Link
              to={getDetailLink(randomItem)}
              className="random-article-card__read-more"
            >
              Devamını Oku
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RandomArticleCard;
